import { CompanyCoreSignatoryMemberType } from '@/types/company';
import { TypedDocumentNode, gql } from '@apollo/client';

type MembersType = { members: CompanyCoreSignatoryMemberType[] };

export type GetCompanyCoreSignatoriesType = {
  orders_companies_by_pk: { core_company: MembersType };
};

export const getCompanyCoreSignatoriesQuery = gql`
  query getCompanyCoreSignatoriesQuery($companyId: bigint!) {
    orders_companies_by_pk(id: $companyId) {
      id
      core_company {
        id: uid
        members(
          where: {
            is_person: { _eq: true }
            core_signatories: { is_active: { _eq: true } }
          }
        ) {
          id
          name_id
          personal_number
          citizenship
          name
          core_signatories {
            member_id
          }
        }
      }
    }
  }
` as TypedDocumentNode<GetCompanyCoreSignatoriesType, { companyId: number }>;
